// import { useQuery } from "@tanstack/react-query";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import { useAuth } from "../../Common/Configurations/AuthContext";

// export const useWebsiteData = (tenant) => { 
//   const { user } = useAuth();
  

//   const queryFn = async () => {
//      const response = await apiService.get(
//       `${config.GETCOMPANYTEMPLATEBYTENANT}/${tenant}`
//     );
//     console.log("API Response for Website Data:", response);
//     const data = response.data || response;

//    return {
//     companyId: data?.companyId, 
//   layout: data?.layoutJson ? JSON.parse(data.layoutJson) : null,

//   style: data?.styleJson ? JSON.parse(data.styleJson) : null,

//   destinations: data?.destinationsJson
//     ? JSON.parse(data.destinationsJson)?.destinations || []
//     : [],

//   heroData: data?.heroJson
//     ? JSON.parse(data.heroJson)
//     : null,

//   branding: data?.customBrandingJson 
//         ? JSON.parse(data.customBrandingJson) 
//         : {},
//   headerMenu: data?.headerJson 
//     ? JSON.parse(data.headerJson) 
//     : (data?.templateVersion?.defaultHeaderJson ? JSON.parse(data.templateVersion.defaultHeaderJson) : []),
//     footerData: data?.footerJson 
//         ? JSON.parse(data.footerJson) 
//         : (data?.templateVersion?.defaultFooterJson ? JSON.parse(data.templateVersion.defaultFooterJson) : {
//             aboutText: "We are a leading travel agency dedicated to providing the best holiday experiences.",
//             copyright: "All Rights Reserved."
//           }),
//     aboutData: data?.aboutUsJson 
//     ? JSON.parse(data.aboutUsJson) 
//     : (data?.templateVersion?.defaultAboutJson ? JSON.parse(data.templateVersion.defaultAboutJson) : {
//         title: "Our Story",
//         description: "We have been organized wonderful tours since 2010...",
//         image: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg"
//       }),
//        contactData: data?.contactUsJson 
//     ? JSON.parse(data.contactUsJson) 
//     : (data?.templateVersion?.defaultContactJson ? JSON.parse(data.templateVersion.defaultContactJson) : {
//         title: "Get In Touch",
//         description: "Have questions? We are here to help you plan your next trip.",
//         mapIframeUrl: "https://www.google.com/maps/embed?pb=!1m18...", // Standard placeholder
//         officeHours: "Mon - Sat: 9:00 AM - 6:00 PM"
//       })
//     };

// };


//   return useQuery({
//    queryKey: ["website-data", tenant],
//     queryFn,
//      enabled: !!tenant, 
//     staleTime: 1000 * 60 * 5,
//     retry: 1,
//   });
// };


import { useQuery } from "@tanstack/react-query";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

export const useWebsiteData = (tenant) => { 
  
  const queryFn = async () => {
     const response = await apiService.get(
      `${config.GETCOMPANYTEMPLATEBYTENANT}/${tenant}`
    );
    console.log("API Response for Website Data:", response);
    const data = response.data || response;

   return {
    companyId: data?.companyId, 
    
    layout: data?.layoutJson ? JSON.parse(data.layoutJson) : null,
    style: data?.styleJson ? JSON.parse(data.styleJson) : null,

    destinations: data?.destinationsJson
      ? JSON.parse(data.destinationsJson)?.destinations || []
      : [],

    heroData: data?.heroJson
      ? JSON.parse(data.heroJson)
      : null,

    branding: data?.customBrandingJson 
          ? JSON.parse(data.customBrandingJson) 
          : {},
          
    headerMenu: data?.headerJson 
      ? JSON.parse(data.headerJson) 
      : (data?.templateVersion?.defaultHeaderJson ? JSON.parse(data.templateVersion.defaultHeaderJson) : []),
      
    footerData: data?.footerJson 
        ? JSON.parse(data.footerJson) 
        : (data?.templateVersion?.defaultFooterJson ? JSON.parse(data.templateVersion.defaultFooterJson) : {
            aboutText: "Discover the world with us.",
            copyright: "All Rights Reserved."
          }),
          
    aboutData: data?.aboutUsJson 
      ? JSON.parse(data.aboutUsJson) 
      : (data?.templateVersion?.defaultAboutJson ? JSON.parse(data.templateVersion.defaultAboutJson) : {
          title: "Our Story",
          description: "We have been organizing wonderful tours since 2010...",
          image: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg"
        }),
        
    contactData: data?.contactUsJson 
      ? JSON.parse(data.contactUsJson) 
      : (data?.templateVersion?.defaultContactJson ? JSON.parse(data.templateVersion.defaultContactJson) : {
          title: "Get In Touch",
          description: "Have questions? We are here to help you plan your next trip.",
          mapIframeUrl: "https://www.google.com/maps/embed?pb=...",
          officeHours: "Mon - Sat: 9:00 AM - 6:00 PM"
        }),

    // 👇 NEW: Capture and parse the SEO JSON data
    seoData: data?.seoJson 
      ? JSON.parse(data.seoJson) 
      : {
          metaTitle: "Welcome to our Travel Agency",
          metaDescription: "Best holiday packages and travel deals.",
          metaKeywords: "travel, tours, packages"
        }
    };
};

  return useQuery({
   queryKey: ["website-data", tenant],
    queryFn,
     enabled: !!tenant, 
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};